import type { VoidFunctionComponent } from 'react';

import { useCurrentProject } from '../../../../hooks/api/projects/useCurrentProject';
import { useCurrentRevision } from '../../../../hooks/api/revisions/useCurrentRevision';
import Loader from '../../../generic/Loader';
import Panel from '../../../generic/Panel';
import { projectTypes } from '../../shared/projectTypesIconMap';

import { ProjectSummaryV2Heading } from './ProjectSummaryV2Heading';

export const ProjectSummaryV2: VoidFunctionComponent = () => {
  const { data: project, isLoading: isProjectLoading } = useCurrentProject();
  const { data: revision, isLoading: isRevisionLoading } = useCurrentRevision();
  const revisionLocator = revision?.locator;

  if (!project || isProjectLoading || !revisionLocator || isRevisionLoading) {
    return (
      <div className="padding-top-sm container">
        <Loader />
      </div>
    );
  }

  const projectTypeTitle = (project.type && projectTypes[project.type]) ? projectTypes[project.type].title : 'Other';

  return (
    <div className="padding-top-xl container">
      <Panel>
        <ProjectSummaryV2Heading projectTypeTitle={projectTypeTitle} revisionLocator={revisionLocator} />
        <div className="padding-top-lg">Project Summary V2 Coming Soon</div>
      </Panel>
    </div>
  );
};
